import style from "./backgroundWrapper.module.scss"
interface BackgroundWrapperProps {
    children: React.ReactNode;
    className?: any
}
export const BackgroundWrapper: React.FC<BackgroundWrapperProps> = ({children,className}) => {
    return <div className={`${style.backgroundWrapper} ${className}`}>{children}</div>;
};